import { Centre } from "./centre";

export class Service {
  id: number;
  nom: string;
  centre: Centre;
  etat: boolean;
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/service.ts